import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import {
  CREATE_EDITOR_USER,
  PAYEMENT_PROCESS,
  CONFIRM_PAYEMENT,
  SET_EDITOR_AUTH,
} from "actions/ActionTypes";
import { postApi } from "actions/SendActions";
import { addUserSession, logout } from "actions/LoginActions";

import CustomLink from "components/customComponents/CustomLink";

import SignupStep1 from "components/signup/SignupStep1";
import SignupStep2 from "components/signup/SignupStep2";
import SignupStep3 from "components/signup/SignupStep3";
import SignupStep4 from "components/signup/SignupStep4";
import StepperEditor from "components/utils/StepperEditor/StepperEditor";

import okast_logo from "resources/okast_logo_black.png";
import okast_animation from "resources/okast_login_remote.gif";

import Auth from "utils/Auth";
import FreshdeskChat from "../freshdeskChat/FreshdeskChat";

import "css/admin/signup.scss";

const FRESHDESK_TOKEN = "85ba5b6f-b957-4eb7-b16b-83a534e37d5b";
const FRESHDESK_HOST = "https://okast.freshchat.com";

export class SignupUI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_step: 0,
      selected_plan: null,
      selected_plan_option: null,
      active_options: null,
      user: null,
      session_token: props.token,
      allowStep: [true, false, false, false],
      plans: null,
      tax_rate_id: null,
      vat_number: "",
    };
  }

  goToStep = (id) => {
    const { allowStep } = this.state;

    if (id < 4 && allowStep[id] === true)
      this.setState({
        current_step: id,
      });
  };

  onChoosePlan = (
    selected_plan,
    active_options,
    selected_plan_option,
    plans,
  ) => {
    let { allowStep, current_step } = this.state;
    const { isLoggedIn } = this.props;

    if (!isLoggedIn) allowStep[1] = true;
    else allowStep[2] = true;

    if (current_step <= -1) current_step++;

    if (isLoggedIn) current_step++;

    this.setState({
      selected_plan,
      active_options,
      selected_plan_option,
      allowStep,
      plans,
      current_step,
    });

    if (current_step >= 1 || isLoggedIn) this.goToStep(2);
    else this.goToStep(1);
  };

  onCreateUser = (user, callbackError) => {
    const { lang } = this.props;
    let { allowStep, current_step } = this.state;
    allowStep[1] = false;
    allowStep[2] = true;

    if (current_step <= 0) current_step++;

    this.setState({ user });
    this.props.createUser(
      user,
      lang,
      (json) => {
        if (json && json.token) {
          this.setState({
            session_token: json.token,
            allowStep,
            current_step,
          });
          this.props.createSession(json.token);
          this.goToStep(2);
        }
      },
      callbackError,
    );
  };

  onPayment = (
    token,
    vat_number,
    country_vat,
    address,
    callback,
    callbackError,
  ) => {
    const { selected_plan_option, active_options, session_token } = this.state;
    const { lang } = this.props;

    const options = [];
    for (const i in active_options) {
      if (active_options[i]) {
        options.push(i);
      }
    }

    this.props.payment(
      token,
      session_token,
      selected_plan_option,
      options,
      lang,
      this.props.t,
      vat_number,
      country_vat,
      address,
      callback,
      callbackError,
    );
  };

  onConfirmPayment = (payment_intent_id, callbackError) => {
    const { session_token } = this.state;

    this.props.confirmPayment(
      payment_intent_id,
      session_token,
      this.props.t,
      this.onConfirmPaymentSuccess,
      callbackError,
    );
  };

  onConfirmPaymentSuccess = (json) => {
    if (json.organization_uuid && json.orga_enabled) {
      this.props.setEditorAuth(json.organization_uuid, json.orga_enabled);
    }

    this.setState(
      {
        allowStep: [false, false, false, true],
      },
      () => this.goToStep(3),
    );
  };

  getStepVisible = (step) => {
    const { selected_plan, selected_plan_option, active_options, plans } =
      this.state;

    switch (step) {
      case 0:
        return (
          <SignupStep1
            onChoosePlan={this.onChoosePlan}
            selected_plan_default={selected_plan}
            selected_plan_option_default={selected_plan_option}
            active_options_default={active_options}
            formated_plans={plans}
          />
        );
      case 1:
        return <SignupStep2 onCreateUser={this.onCreateUser} />;
      case 2:
        return (
          <SignupStep3
            onPayment={this.onPayment}
            onConfirmPayment={this.onConfirmPayment}
            selected_plan={selected_plan}
            active_options={active_options}
          />
        );
      case 3:
        return <SignupStep4 />;
      default:
        return <SignupStep1 />;
    }
  };

  getSteps = () => {
    const { t } = this.props;
    return [
      { label: t("step_1") },
      { label: t("step_2") },
      { label: t("step_3") },
      {
        label: t("take_off"),
        icon: <i className="material-icons">flight_takeoff</i>,
      },
    ];
  };

  getLinksPanel = () => {
    const { t } = this.props;
    return (
      <>
        <div className="form-group">
          <a className="help-block" href="mailto:hello@okast.tv">
            {t("contactUs")}
          </a>
        </div>
        <div className="form-group">
          <a
            className="help-block"
            href="https://calendly.com/okast-tv/okast-meeting"
          >
            {t("bookSlot")}
          </a>
        </div>
      </>
    );
  };

  getLoginPanel = () => {
    const { onLogout, isLoggedIn, token, redirectTo, t } = this.props;

    if (isLoggedIn) {
      return (
        <div className="form-group">
          <CustomLink
            className="browse-item browse-list-item"
            isRouterLink={false}
            namespace="header"
            onClick={() => {
              onLogout(token, redirectTo);
            }}
          >
            {t("logoutTitle")}
          </CustomLink>
        </div>
      );
    }
    return (
      <div className="form-group">
        <NavLink to="login" className="help-block">
          {t("loginTitle")}
        </NavLink>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    const { current_step } = this.state;

    return (
      <div className="signup-admin-container">
        <div className="beamerTrigger" style={{ display: "none" }} />
        <div className="signup-panel-illustration-container">
          <div className="signup-panel-illustration">
            <img className="okast-logo dark:invert" src={okast_logo} />
            <img className="okast-remote-logo" src={okast_animation} />
            {this.getLinksPanel()}
            {this.getLoginPanel()}
          </div>
        </div>
        <div className="signup-panel">
          <div className="signup-steps">
            <div className="editor-stepper-signup-container editor-stepper-linear editor-stepper-small">
              <StepperEditor
                activeStep={current_step}
                goToStep={this.goToStep}
                steps={this.getSteps()}
              />
            </div>
          </div>
          <div className="signup-step-title">
            {t(`titleStep${current_step}`)}
            {current_step === 0 && (
              <span className="signup-step-subtitle">
                {t(`subtitleStep${current_step}`)}
              </span>
            )}
          </div>
          {this.getStepVisible(current_step)}
        </div>
        <FreshdeskChat token={FRESHDESK_TOKEN} host={FRESHDESK_HOST} />
      </div>
    );
  }
}

SignupUI.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  createUser: PropTypes.func.isRequired,
  payment: PropTypes.func.isRequired,
  confirmPayment: PropTypes.func.isRequired,
  createSession: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  redirectTo: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  setEditorAuth: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { isLoggedIn, token } = state.loginReducer;
  const { lang } = state.variableReducer;

  return {
    isLoggedIn,
    token,
    lang,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createUser(user, lang, callback, callbackError) {
    dispatch(
      postApi({
        endpoint: "/api/user/v3/admin/new_client/editor",
        type: CREATE_EDITOR_USER,
        data: {
          email: user.email,
          password: user.password,
          first_name: user.first_name,
          last_name: user.last_name,
          organization: user.organization,
          lang,
        },
        callback,
        callbackError,
      }),
    );
  },
  payment(
    stripe_token,
    session_token,
    plan,
    plan_options,
    lang,
    t,
    vat_number,
    country_vat,
    address,
    callback,
    callbackError,
  ) {
    dispatch(
      postApi({
        endpoint: "/api/user/v3/admin/payment_process",
        type: PAYEMENT_PROCESS,
        token: session_token,
        data: {
          token_card: stripe_token,
          plan_uuid: plan,
          plan_options,
          currency: "eur",
          vat_number,
          country_vat: country_vat.value,
          address,
          lang,
        },
        callback,
        callbackError,
      }),
    );
  },
  confirmPayment(payment_intent_id, session_token, t, callback, callbackError) {
    dispatch(
      postApi({
        endpoint: "/api/user/v3/admin/confirm_payment",
        type: CONFIRM_PAYEMENT,
        token: session_token,
        data: {
          payment_intent_id,
        },
        message: t("paymentSucceeded"),
        error: t("error:errorStripe"),
        callback,
        callbackError,
      }),
    );
  },
  createSession(token) {
    const { localStorage } = global.window;

    localStorage.logged = "true";
    localStorage.token = token || "";
    dispatch(addUserSession());
  },
  setEditorAuth(orga_uuid, orga_enabled) {
    Auth.setEditorAuth(orga_uuid, orga_enabled);
    dispatch({
      type: SET_EDITOR_AUTH,
      editorAuth: orga_enabled,
      organization_uuid: orga_uuid,
    });
  },
  onLogout(token, redirectTo) {
    dispatch(logout(token, null, redirectTo));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("editor-signup", "error")(SignupUI));
